/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */
export const OFFSET_TOP = 40;



// WEBPACK FOOTER //
// ./source/config.js